import * as types from './types';
import { loading, handleErrorException } from 'State/actions';
import { GENERIC_ERROR_MESSAGE } from 'Common/Constants';

const getDataError = {
  Title: 'Error',
  Message: GENERIC_ERROR_MESSAGE,
};

export const getExportFileType = fileTypes => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GENERIC_EXPORT_SETUP_SET_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('Export/ExportFileType');

      dispatch({
        type: types.GENERIC_EXPORT_SETUP_GET_EXPORTFILETYPE,
        payload: response.data,
      });
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.GENERIC_EXPORT_SETUP_ERROR,
          getDataError
        )
      );
    }

    dispatch(loading(types.GENERIC_EXPORT_SETUP_SET_LOADING, false));
  };
};

export const getExportFileField = fileTypeId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GENERIC_EXPORT_SETUP_SET_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `Export/ExportFileField/${fileTypeId}`
      );

      dispatch({
        type: types.GENERIC_EXPORT_SETUP_GET_EXPORTFILEFIELD,
        payload: { ...response.data, exportFileType: fileTypeId },
      });
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.GENERIC_EXPORT_SETUP_ERROR,
          getDataError
        )
      );
    }

    dispatch(loading(types.GENERIC_EXPORT_SETUP_SET_LOADING, false));
  };
};

export const writeGenericExportSetup = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GENERIC_EXPORT_SETUP_SET_SUBMITTING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(`Export/ExportFileField`, model);

      dispatch(setSaveSuccessful(true));
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.GENERIC_EXPORT_SETUP_ERROR,
          getDataError
        )
      );
    }

    dispatch(loading(types.GENERIC_EXPORT_SETUP_SET_SUBMITTING, false));
  };
};

export const setSaveSuccessful = value => {
  return {
    type: types.GENERIC_EXPORT_SETUP_SET_SUCCESSFUL,
    payload: value,
  };
};

export const setExportFileType = value => {
  return {
    type: types.GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPE,
    payload: value,
  };
};

export const setExportFileTypeFuture = value => {
  return {
    type: types.GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPEFUTURE,
    payload: value,
  };
};

export const clearError = value => {
  return {
    type: types.GENERIC_EXPORT_SETUP_CLEAR_ERROR,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/state/setup/actions.js